import http from "@/http-common";
import './security';
import Constants from "@/Constants";

class DataService {

    async doRequest(url, idsensor, serverParams) {
        //Parametros
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
        var token = localStorage.getItem('jwt');
        var data = {};

        //Hacemos una request normal al servidor para qeu lo devuelva en JSON por defecto y parametrizado
        if ((serverParams) && (!serverParams.csvoptions)) {
            data = {
                headers: { jwt: token, ssid: ssid, id_sensor: idsensor, serverParams: JSON.stringify(serverParams) }
            };
            //Hacemos una request para solicitar qeu se devuelva una descarga en stream tipo BLOB
        } else if ((serverParams) && (serverParams.csvoptions.format == "blob")) {
            data = {
                headers: { 'jwt': token, 'ssid': ssid, 'id_sensor': idsensor, serverParams: JSON.stringify(serverParams) },
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    let percentCompleted = (progressEvent.loaded / 1024 / 1024);
                    sessionStorage.setItem('CSVProgressbar', percentCompleted.toFixed(2))
                }
            };
            //Descarga normal para en JSON por defecto
        } else {
            data = {
                headers: { jwt: token, ssid: ssid, id_sensor: idsensor }
            };
        };

        // RETURN response
        return await http.get(url, data)
    }


    async getAllAccelBMA400Data(idsensor, serverParams) {
        return await this.doRequest(`/data/accel/bma400/${idsensor}`, idsensor, serverParams)
    }

    async getAllAccelADXL355Data(idsensor, serverParams) {
        return await this.doRequest(`/data/accel/adxl355/${idsensor}`, idsensor, serverParams)
    }

    async getAllTempI2CData(idsensor, serverParams) {
        return await this.doRequest(`/data/temphum/i2c/${idsensor}`, idsensor, serverParams)
    }

    async getAllTempSHT20Data(idsensor, serverParams) {
        return await this.doRequest(`/data/temphum/sht20/${idsensor}`, idsensor, serverParams)
    }

    async getAllFlowReedData(idsensor, serverParams) {
        return await this.doRequest(`/data/flow/reed/${idsensor}`, idsensor, serverParams)
    }

    async getAllFlowHidrojetData(idsensor, serverParams) {
        return await this.doRequest(`/data/flow/hidrojet/${idsensor}`, idsensor, serverParams)
    }

    async getAllTempAnalogData(idsensor, serverParams) {
        return await this.doRequest(`/data/tempanalog/${idsensor}`, idsensor, serverParams)
    }

    async getAllTensionADCData(idsensor, serverParams) {
        return await this.doRequest(`/data/tensionadc/${idsensor}`, idsensor, serverParams)
    }

    async getAllGalgaData(idsensor, serverParams) {
        return await this.doRequest(`/data/galga/${idsensor}`, idsensor, serverParams)
    }

    async getAllPiezometroData(idsensor, serverParams) {
        return await this.doRequest(`/data/piezometro/${idsensor}`, idsensor, serverParams)
    }

    async getAllMeteoData(idsensor, serverParams) {
        return await this.doRequest(`/data/meteo/${idsensor}`, idsensor, serverParams)
    }

    async getAllLedData(idsensor, serverParams) {
        return await this.doRequest(`/data/led/${idsensor}`, idsensor, serverParams)
    }

    async getAllCarDetectorData(idsensor, serverParams) {
        return await this.doRequest(`/data/cardetector/${idsensor}`, idsensor, serverParams)
    }

    async getAllVisibilityData(idsensor, serverParams) {
        return await this.doRequest(`/data/visibility/${idsensor}`, idsensor, serverParams)
    }

    async getAllSpeedData(idsensor, serverParams) {
        return await this.doRequest(`/data/speed/${idsensor}`, idsensor, serverParams)
    }

    async getAllLuminosityData(idsensor, serverParams) {
        return await this.doRequest(`/data/luminosity/${idsensor}`, idsensor, serverParams)
    }

    async getAllGpsData(idsensor, serverParams) {
        return await this.doRequest(`/data/gps/${idsensor}`, idsensor, serverParams)
    }

    async getAllTemp4AnalogData(idsensor, serverParams) {
        return await this.doRequest(`/data/temp4analog/${idsensor}`, idsensor, serverParams)
    }

    async getAllCoverageData(idsensor, serverParams) {
        return await this.doRequest(`/data/coverage/${idsensor}`, idsensor, serverParams)
    }

    async getAllCbHobutData(idsensor, serverParams) {
        return await this.doRequest(`/data/cthobut/${idsensor}`, idsensor, serverParams)
    }

    async getAllCbHobut3Data(idsensor, serverParams) {
        return await this.doRequest(`/data/cthobut3/${idsensor}`, idsensor, serverParams)
    }


    async getAllPluviometro(idsensor, serverParams) {
        return await this.doRequest(`/data/pluviometro/ws2080/${idsensor}`, idsensor, serverParams)
    }

    async getAllAdcTemp(idsensor, serverParams) {
        return await this.doRequest(`/data/adctemp/${idsensor}`, idsensor, serverParams)
    }

    async getAllFLOWGIEData(idsensor, serverParams) {
        return await this.doRequest(`/data/flowgie/${idsensor}`, idsensor, serverParams)
    }

    async getAllWATERQUALITYData(idsensor, serverParams) {
        return await this.doRequest(`/data/waterquality/${idsensor}`, idsensor, serverParams)
    }
    async getAllFlowFlowmeterData(idsensor, serverParams) {
        return await this.doRequest(`/data/flow/flowmeter/${idsensor}`, idsensor, serverParams)
    }
    async getAllAlarmsAlarmSensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/alarmsensor/${idsensor}`, idsensor, serverParams)
    }
    async getAllPressureDps310SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/pressure/dps310/${idsensor}`, idsensor, serverParams)
    }
    async getAllPressureVegabar29SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/pressure/vegabar29/${idsensor}`, idsensor, serverParams)
    }
    async getAllValveUss200078SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/valve/uss200078/${idsensor}`, idsensor, serverParams)
    }
    async getAllCalexExtempSensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/temp/calextemp/${idsensor}`, idsensor, serverParams)
    }
    async getAllT3110ExSensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/temphum/t3110ex/${idsensor}`, idsensor, serverParams)
    }
    async getAllrocioSensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/hum/rocio/${idsensor}`, idsensor, serverParams)
    }
    async getAllS451CaudalimetroSensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/hum/caudalimetro/${idsensor}`, idsensor, serverParams)
    }
    async getAllSEN0482SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/dir/sen0482/${idsensor}`, idsensor, serverParams)
    }
    async getAllSEN0483SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/veloc/sen0483/${idsensor}`, idsensor, serverParams)
    }
    async getAllSEN0438SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/temphum/sen0438/${idsensor}`, idsensor, serverParams)
    }
    async getAllSEN0604SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/temphum/sen0604/${idsensor}`, idsensor, serverParams)
    }
    async getAllSEN0605SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/sen0605/${idsensor}`, idsensor, serverParams)
    }
    async getAllSZFS02SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/rad/szfs02/${idsensor}`, idsensor, serverParams)
    }

    async getAllSCD41SensorData(idsensor, serverParams) {
        return await this.doRequest(`/data/scd41/${idsensor}`, idsensor, serverParams)
    }

    getAllData(id_sensor, id_sensor_type, serverParams) {
        switch (id_sensor_type.toString()) {
            // ID del acelerómetro BMA-400
            case Constants.ID_SENSOR_TYPES.BMA400.toString():
                return this.getAllAccelBMA400Data(id_sensor, serverParams);
            // ID del acelerómetro ADXL355
            case Constants.ID_SENSOR_TYPES.ADXL355.toString():
                return this.getAllAccelADXL355Data(id_sensor, serverParams);
            // Temperatura I2C
            case Constants.ID_SENSOR_TYPES.TEMPI2C.toString():
                return this.getAllTempI2CData(id_sensor, serverParams);
            // Temperatura SHT20
            case Constants.ID_SENSOR_TYPES.TEMPSHT20.toString():
                return this.getAllTempSHT20Data(id_sensor, serverParams);
            // Caudal REED
            case Constants.ID_SENSOR_TYPES.FLOWREED.toString():
                return this.getAllFlowReedData(id_sensor, serverParams);
            // Caudal Hidrojet
            case Constants.ID_SENSOR_TYPES.FLOWHIDROJET.toString():
                return this.getAllFlowHidrojetData(id_sensor, serverParams);
            // Temperatura analógica
            case Constants.ID_SENSOR_TYPES.TEMPANALOG.toString():
                return this.getAllTempAnalogData(id_sensor, serverParams);
            // Tensión ADC
            case Constants.ID_SENSOR_TYPES.TENSIONADC.toString():
                return this.getAllTensionADCData(id_sensor, serverParams);
            // Galga extensiométrica
            case Constants.ID_SENSOR_TYPES.GALGA.toString():
                return this.getAllGalgaData(id_sensor, serverParams);
            // Piezometro VEGAWELL
            case Constants.ID_SENSOR_TYPES.PIEZOMETRO.toString():
                return this.getAllPiezometroData(id_sensor, serverParams);
            // Meteorológico
            case Constants.ID_SENSOR_TYPES.METEO.toString():
                return this.getAllMeteoData(id_sensor, serverParams);
            // Iluminación led
            case Constants.ID_SENSOR_TYPES.LED.toString():
                return this.getAllLedData(id_sensor, serverParams);
            // Detector de coches
            case Constants.ID_SENSOR_TYPES.CARDETECTOR.toString():
                return this.getAllCarDetectorData(id_sensor, serverParams);
            // Visibilidad
            case Constants.ID_SENSOR_TYPES.VISIBILIDAD.toString():
                return this.getAllVisibilityData(id_sensor, serverParams);
            // Velocidad
            case Constants.ID_SENSOR_TYPES.VELOCIDAD.toString():
                return this.getAllSpeedData(id_sensor, serverParams);
            // Luminosidad
            case Constants.ID_SENSOR_TYPES.LUMINOSIDAD.toString():
                return this.getAllLuminosityData(id_sensor, serverParams);
            // GPS
            case Constants.ID_SENSOR_TYPES.GPS.toString():
                return this.getAllGpsData(id_sensor, serverParams);
            // Temperatura analógica 4 canales
            case Constants.ID_SENSOR_TYPES.TEMP4NALOG.toString():
                return this.getAllTemp4AnalogData(id_sensor, serverParams);
            // Cobertura
            case Constants.ID_SENSOR_TYPES.COBERTURA.toString():
                return this.getAllCoverageData(id_sensor, serverParams);
            // Transformador CT-HOBUT
            case Constants.ID_SENSOR_TYPES.CT_HOBUT.toString():
                return this.getAllCbHobutData(id_sensor, serverParams);
            // Transformador CT-HOBUT
            case Constants.ID_SENSOR_TYPES.CTHOBUT3.toString():
                return this.getAllCbHobut3Data(id_sensor, serverParams);
            // Pluviometro WS2080
            case Constants.ID_SENSOR_TYPES.PLUVIOMETRO_WS2080.toString():
                return this.getAllPluviometro(id_sensor, serverParams);
            // AC-TEMP Atlantic Copper
            case Constants.ID_SENSOR_TYPES.ADCTEMP.toString():
                return this.getAllAdcTemp(id_sensor, serverParams);
            // Contador AGUA GIE
            case Constants.ID_SENSOR_TYPES.FLOWGIE.toString():
                return this.getAllFLOWGIEData(id_sensor, serverParams);
            // Calidad AGUA GIE
            case Constants.ID_SENSOR_TYPES.WATERQUALITY.toString():
                return this.getAllWATERQUALITYData(id_sensor, serverParams);
            // Medidor de caudal flowmeter
            case Constants.ID_SENSOR_TYPES.FLOWMETER.toString():
                return this.getAllFlowFlowmeterData(id_sensor, serverParams);
            // Sensor de alarma ALARMSENSOR
            case Constants.ID_SENSOR_TYPES.ALARMSENSOR.toString():
                return this.getAllAlarmsAlarmSensorData(id_sensor, serverParams);
            // Sensor de presion PRESSURESENSOR dps310
            case Constants.ID_SENSOR_TYPES.PRESSURESENSOR.toString():
                return this.getAllPressureDps310SensorData(id_sensor, serverParams);
            // Sensor de VEGABAR-29
            case Constants.ID_SENSOR_TYPES.PRESSUREVEGABARSENSOR.toString():
                return this.getAllPressureVegabar29SensorData(id_sensor, serverParams);
            // Sensor de válvula  VALVESENSOR USS2-00078
            case Constants.ID_SENSOR_TYPES.VALVESENSOR.toString():
                return this.getAllValveUss200078SensorData(id_sensor, serverParams);
            case Constants.ID_SENSOR_TYPES.TEMPCALEXTEMPSENSOR.toString():
                return this.getAllCalexExtempSensorData(id_sensor, serverParams);
            case Constants.ID_SENSOR_TYPES.T3110EXSENSOR.toString():
                return this.getAllCalexExtempSensorData(id_sensor, serverParams);
            case Constants.ID_SENSOR_TYPES.ROCIOSENSOR.toString():
                return this.getAllrocioSensorData(id_sensor, serverParams);
            //Sensor S451_Caudalimetro
            case Constants.ID_SENSOR_TYPES.S451_CAUDALIMETRO.toString():
                return this.getAllS451CaudalimetroSensorData(id_sensor, serverParams);
            case Constants.ID_SENSOR_TYPES.SZFS02.toString():
                return this.getAllSZFS02SensorData(id_sensor, serverParams);

            case Constants.ID_SENSOR_TYPES.SEN0482.toString():
                return this.getAllSEN0482SensorData(id_sensor, serverParams);

            case Constants.ID_SENSOR_TYPES.SEN0483.toString():
                return this.getAllSEN0483SensorData(id_sensor, serverParams);

            case Constants.ID_SENSOR_TYPES.SEN0438.toString():
                return this.getAllSEN0438SensorData(id_sensor, serverParams);

            case Constants.ID_SENSOR_TYPES.SEN0604.toString():
                return this.getAllSEN0604SensorData(id_sensor, serverParams);

            case Constants.ID_SENSOR_TYPES.SEN0605.toString():
                return this.getAllSEN0605SensorData(id_sensor, serverParams);

            case Constants.ID_SENSOR_TYPES.SCD41.toString():
                return this.getAllSCD41SensorData(id_sensor, serverParams);

            default:
                throw new Error('Error - DataService.js - id_sensor_type unknown')
        }
    }

    /* async getAllAlarmsData() {
        //var data = {headers:{jwt : token, ssid : ssid}}
        return await this.doRequest(`/data/alarm`, null, null)
    }

    deleteAllAlarms() {
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
        var token = localStorage.getItem('jwt');
        var data = {headers:{jwt : token, ssid : ssid}}
    
        return http.delete("/data/alarm", data);
    }

    attendAlarm(data) {
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
        var token = localStorage.getItem('jwt');
        var resData = {};
        resData.jwt = token;
        resData.ssid = ssid;
        resData.ssidAlarm = data;   

        return http.post(`/data/alarm`, resData);
    }*/

    getSismoDataByLocationId(id, serverParams) {
        let data = {
            headers: { serverParams: JSON.stringify(serverParams) }
        };
        return http.get(`/data/sismo/${id}`, data);
    }

}

export default new DataService();